<iss-typeahead-select
  [formControl]="control.control"
  [items$]="items$"
  [loading$]="loading$"
  [placeholder]="placeholder || 'iss-wo-common.label.waste-type' | translate"
  [readonly]="readonly"
  [loading]="loading"
  [stringify]="stringify"
  [content]="content"
  [identity]="identity"
  [matcher]="matcher"
  [clearable]="clearable"
  [multi]="multi"
  [withAll]="multi"
>
  <wo-waste-type
    *issTypeaheadSelectItem="let wasteType=item"
    [name]="wasteType.presentedName"
    [ewcCode]="wasteType.ewcCode"
  />
  <ng-content/>
</iss-typeahead-select>
